module.exports = __webpack_public_path__ + "static/media/figma.cdbed025.png";